// ligfrontend/src/components/common/InlineEditor.jsx
import React, { useState, useRef, useEffect } from "react";
import "./InlineEditor.css";

const InlineEditor = ({
  value,
  onSave,
  onDelete,
  centerText = false,
  multiline = false,
  showQuotes = false,
  className = "",
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState(value);
  const inputRef = useRef(null);

  useEffect(() => {
    setEditValue(value);
  }, [value]);

  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus();
      if (multiline) {
        inputRef.current.select();
      }
    }
  }, [isEditing, multiline]);

  const handleSave = () => {
    if (editValue.trim() !== value.trim()) {
      onSave(editValue.trim());
    }
    setIsEditing(false);
  };

  const handleCancel = () => {
    setEditValue(value);
    setIsEditing(false);
  };

  const handleKeyDown = (e) => {
    if (!multiline && e.key === "Enter") {
      e.preventDefault();
      handleSave();
    } else if (e.key === "Escape") {
      handleCancel();
    }
  };

  if (isEditing) {
    return (
      <div className={`inline-editor editing ${className}`}>
        {multiline ? (
          <textarea
            ref={inputRef}
            value={editValue}
            onChange={(e) => setEditValue(e.target.value)}
            onKeyDown={handleKeyDown}
            className="inline-editor-textarea"
            rows={4}
          />
        ) : (
          <input
            ref={inputRef}
            type="text"
            value={editValue}
            onChange={(e) => setEditValue(e.target.value)}
            onKeyDown={handleKeyDown}
            className="inline-editor-input"
            style={{ textAlign: centerText ? "center" : "left" }}
          />
        )}
        <div className="inline-editor-actions">
          <button onClick={handleSave} className="btn-save">
            ✓ Save
          </button>
          <button onClick={handleCancel} className="btn-cancel">
            ✕ Cancel
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className={`inline-editor ${className}`}>
      <div
        className="inline-editor-display"
        onClick={() => setIsEditing(true)}
        style={{ textAlign: centerText ? "center" : "left" }}
      >
        {showQuotes && <span className="quote-left">❝</span>}
        <span className="inline-editor-text">{value}</span>
        {showQuotes && <span className="quote-right">❞</span>}
      </div>
      {onDelete && (
        <button onClick={onDelete} className="btn-delete-inline" title="Delete">
          🗑️
        </button>
      )}
    </div>
  );
};

export default InlineEditor;
